





























import { Vue, Component } from "vue-property-decorator";
import { Login as ILogin } from "@/interface/login";
import { ResponseUserInfo } from "@/interface/common";
import { login } from "@/http/login.api";
@Component
export default class Login extends Vue {
  form: ILogin = {
    mobile: "",
    password: ""
  };
  rules = {
    mobile: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
    password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
  };
  async onSubmit() {
    const loginRef = this.$refs.login as any;
    const valid = await loginRef.validate();
    if (!valid) return;
    const data = await login<ResponseUserInfo>(this.form);
        document.cookie= `mobile=${this.form.mobile}`;
    this.$store.commit("SET_USER", data);
    sessionStorage.setItem("userInfo", JSON.stringify(data));
    this.$router.push('/100')
  }
}
